var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6CC04A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M10 6.884c.686 0 1.232-.546 1.232-1.232 0-.686-.546-1.232-1.232-1.232-.686 0-1.232.546-1.232 1.232 0 .686.546 1.232 1.232 1.232zm1.078 7.616V7.738H8.922V14.5h2.156z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMwLjAwMDAwMCwgLTE2Ni4wMDAwMDApIHRyYW5zbGF0ZSgyMC4wMDAwMDAsIDE1Ni4wMDAwMDApIHRyYW5zbGF0ZSgxMC4wMDAwMDAsIDEwLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIiBmaWxsPSIjNkNDMDRBIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzI2MjYyNiIgZD0iTTEwIDYuODg0Yy42ODYgMCAxLjIzMi0uNTQ2IDEuMjMyLTEuMjMyIDAtLjY4Ni0uNTQ2LTEuMjMyLTEuMjMyLTEuMjMyLS42ODYgMC0xLjIzMi41NDYtMS4yMzIgMS4yMzIgMCAuNjg2LjU0NiAxLjIzMiAxLjIzMiAxLjIzMnptMS4wNzggNy42MTZWNy43MzhIOC45MjJWMTQuNWgyLjE1NnoiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconInfo as ReactComponent };